<template>
  <div>
    <form v-if="setData()">
      <v-layout wrap v-if="dateInfo=='date'">
        <v-flex xs4>
          <v-text-field value="DD/MM/YYYY" disabled> </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="dateInfo=='time'">
        <v-flex xs4>
          <v-text-field  value="HH:MM" disabled> </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="dateInfo=='date & time'">
        <v-flex xs4>
          <v-text-field value="DD/MM/YYYY" disabled> </v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field value="HH:MM" disabled> </v-text-field>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title>
          <span class="material-icons">
            event
          </span>
          <button>option</button>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout>
            <v-flex xs4>
              Type
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-select
                :items="items"
                item-text="name"
                item-value="id"
                v-model="dataValue"
                :label="getLabel"
                solo
                @change="item($event)"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </form>
  </div>
</template>

<script>
export default {
  props: { dateInfo: String },
  data: () => ({
    date: false,
    time: false,
    dateTime: true,
    dataValue:null,
    items: [
      { id: "date", name: "Date only" },
      { id: "time", name: "Time only" },
      { id: "date & time", name: "Date & Time" },
      
    ],
  }),
  created() {
    this.item(this.dateInfo);
    // console.log(this.dateInfo);
  },
  computed: {
    getLabel() {
      if (this.dateInfo != "") {
        if(this.dateInfo == "date"){
          return "Date only";
        }else if(this.dateInfo == "time"){
          return "Time only";
        }
        return "Date & Time";
      } else {
        return "Select Type";
      }
    },
  },
  methods: {
    item(id) {
      // console.log('iddata'+id);
      
      if (id == "date") {
        this.dateTime = false;
        this.date = true;
        this.time = false;
      } else if (id == "time") {
        this.dateTime = false;
        this.time = true;
        this.date = false;
      } else {
        this.time = false;
        this.date = false;
        this.dateTime = true;
      }

      this.$emit("change", id);
    },
    setData(){
      if (this.dateInfo != "") {
        this.dataValue = this.dateInfo;
      }else{
        this.dateInfo = "date & time"
      }
      return true;
    }
  },
};
</script>
